import React, { useState } from "react";
import logo from "./logo.svg";
import "./App.scss";
import add from "./img/add.svg";
import cross from "./img/cross.svg";
import CustomInput from "./components/CustomInput";
import PhoneInput from "./components/PhoneInput/PhoneInput";
import DropdownInput from "./components/DropdownInput/DropdownInput";
import AdditionalInput from "./components/AdditionalInput/AdditionalInput";
import { getNameOfJSDocTypedef } from "typescript";

function App() {
  const [options, setOptions] = useState([
    "Місце роботи",
    "Професія",
    "Вік",
    "Дата народження",
  ]);
  const [additionalFieldsNumber, setAdditionalFieldsNumber] = useState<
    number[]
  >([]);
  const [number, setNumber] = useState<number>(0);
  const onAdd = () => {
    additionalFieldsNumber.length < 4 &&
      setAdditionalFieldsNumber((prev) => {
        setNumber((prev) => prev + 1);
        const add = [...prev, number];
        return add;
      });
    console.log(additionalFieldsNumber);
  };

  return (
    <div className="App">
      <div className="form-container">
        <div className="form-content">
          <div className="form__header">
            <div className="header__text-group">
              <div className="header__img">
                <img src={add} alt="" />
              </div>
              <div className="header__text">Додати користувача</div>
            </div>
            <div className="close">
              <img src={cross} alt="" />
            </div>
          </div>
          <div className="line"></div>
          <form action="" className="form">
            <CustomInput title="Ім’я" placeholder="Марина" />
            <CustomInput title="Прізвище" placeholder="Коноваленко" />
            <PhoneInput />
            <CustomInput
              title="Email"
              placeholder="example.com"
              style={{ marginLeft: "-16px" }}
            />
            <DropdownInput
              title="Група користувачiв"
              placeholder="Оберiть групу"
              options={["Перша", "Друга", "Третя"]}
            />
            <DropdownInput
              title="Мова"
              placeholder="Оберiть мову"
              options={["Англійська", "Українська", "Німецька", "Французька"]}
            />

            <>
              {additionalFieldsNumber.map((i) => {
                return (
                  <AdditionalInput
                    options={options}
                    key={i}
                    setOptions={setOptions}
                  />
                );
              })}
            </>
            <div
              className={`add ${
                additionalFieldsNumber.length > 3 && "disabled"
              }`}
            >
              <a onClick={onAdd}>Додати поле</a>
            </div>
            <button className="submit">Додати користувача</button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default App;
